import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';

export default props => {
  return (
    <Dimmer active>
      <Loader content="Loading" size="huge" />
    </Dimmer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Loader.js